import { Playground } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';
import { staticAssetsUrl } from '../../../staticAssets';

const logo = `${staticAssetsUrl}/logos/logo_rio_dark.svg`;

const eachBackgroundSize = ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];
const eachBackgroundPositions = [
    'top-left',
    'top',
    'top-right',
    'center-right',
    'bottom-right',
    'bottom',
    'bottom-left',
    'center-left',
];
const eachBackgroundRepeat = ['no', 'xy', 'x', 'y'];

export const Background = () => (
    <div>
        <Headline anchor='background'>Background</Headline>
        <Playground example={backgroundExample} classes={opacityClasses} />
    </div>
);

const backgroundExample = (
    <div>
        <Headline anchor='background-size' headlineType='h4' headlineNoTopSpace>
            Background size
        </Headline>
        <div className='display-flex flex-wrap gap-10'>
            {eachBackgroundSize.map((value, index) => (
                <div
                    className={`width-100 aspect-ratio-1 bg-size-${value}pct bg-repeat-no bg-light`}
                    style={{ backgroundImage: `url(${logo})` }}
                    key={index}
                />
            ))}
        </div>
        <Headline anchor='background-position' headlineType='h4'>
            Background position
        </Headline>
        <div className='display-flex flex-wrap gap-10'>
            {eachBackgroundPositions.map((value, index) => (
                <div
                    className={`width-100 aspect-ratio-1 bg-size-20pct bg-position-${value} bg-repeat-no bg-light`}
                    style={{ backgroundImage: `url(${logo})` }}
                    key={index}
                />
            ))}
        </div>
        <Headline anchor='background-repeat' headlineType='h4'>
            Background repeat
        </Headline>
        <div className='display-flex flex-wrap gap-10'>
            {eachBackgroundRepeat.map((value, index) => (
                <div
                    className={`width-100 aspect-ratio-1 bg-size-20pct bg-position-center bg-repeat-${value} bg-light`}
                    style={{ backgroundImage: `url(${logo})` }}
                    key={index}
                />
            ))}
        </div>
    </div>
);

const opacityClasses = (
    <>
        <PlaygroundClasses label='Hide' classes='bg-none' />
        <PlaygroundClasses label='Size' prefix='bg-size-' classes={['cover', ...eachBackgroundSize]} />
        <PlaygroundClasses label='Position' prefix='bg-position-' classes={eachBackgroundPositions} />
        <PlaygroundClasses label='Repeat' prefix='bg-repeat-' classes={eachBackgroundRepeat} />
        <PlaygroundClasses label='Fixed' classes='bg-attachment-fixed' />
    </>
);
